import { Capacitor } from "@capacitor/core";
import { type MissionsManager } from "@rescuetablet/missions-client";
import { type Logger } from "../log";

export async function createMissionsManager(args: {
  baseUrl?: string;
  userAgent?: string;
  logger: Logger;
}): Promise<MissionsManager> {
  const impl = await (Capacitor.isNativePlatform()
    ? import("./connect-native")
    : import("@rescuetablet/missions-client/browser"));
  return impl.createMissionsManager(args);
}
